import { Truck, Recycle } from "lucide-react"

const Prices = () => {
  return (
    <section id="tarifs" className="py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Services et Tarifs Ferrailleur Épaviste à Saint-Étienne</h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Zak, votre ferrailleur épaviste à Saint-Étienne, vous propose les meilleurs prix du marché pour le rachat de vos métaux et l'enlèvement gratuit d'épaves
            dans la Loire, la Haute-Loire et le Rhône.
          </p>
        </div>

        <div className="flex justify-center">
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl">
            {/* Carte d'enlèvement de véhicule */}
            <div className="rounded-lg overflow-hidden shadow-md transition-transform hover:transform hover:scale-105 border-2 border-green-500 relative">
              <div className="absolute top-0 right-0 bg-green-500 text-white px-4 py-1 text-sm font-bold">Gratuit</div>
              <div className="p-6 bg-white">
                <div className="flex justify-center mb-4">
                  <Truck className="h-16 w-16 text-green-600" />
                </div>
                <h3 className="text-2xl font-bold text-center mb-2">Épaviste Saint-Étienne - Enlèvement de Véhicules</h3>
                <div className="text-center mb-6">
                  <span className="text-3xl font-bold text-green-600">GRATUIT</span>
                </div>
                <ul className="space-y-3">
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">Enlèvement d'épave gratuit à Saint-Étienne et alentours</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">Intervention rapide sous 48h</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">Certificat de cession remis sur place</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">Saint-Étienne, Loire (42), Haute-Loire (43), Rhône (69)</span>
                  </li>
                </ul>
              </div>
              <div className="p-4 bg-gray-50">
                <a
                  href="#contact"
                  className="block text-center py-2 px-4 rounded font-medium transition-colors bg-green-600 hover:bg-green-700 text-white"
                  aria-label="Demander un enlèvement d'épave gratuit à Saint-Étienne"
                >
                  Demander un enlèvement gratuit
                </a>
              </div>
            </div>

            {/* Carte de rachat de métaux */}
            <div className="rounded-lg overflow-hidden shadow-md transition-transform hover:transform hover:scale-105 border border-gray-200">
              <div className="p-6 bg-white">
                <div className="flex justify-center mb-4">
                  <Recycle className="h-16 w-16 text-green-600" />
                </div>
                <h3 className="text-2xl font-bold text-center mb-2">Ferrailleur Saint-Étienne - Rachat de Métaux</h3>
                <div className="text-center mb-6">
                  <span className="text-3xl font-bold text-green-600">Meilleurs prix du marché</span>
                  <span className="text-gray-700 block text-sm">Mise à jour hebdomadaire</span>
                </div>
                <ul className="space-y-3">
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">Rachat de cuivre, laiton, aluminium, ferraille à Saint-Étienne</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">Pesée certifiée et transparente</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">Paiement immédiat au meilleur tarif</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">Pour particuliers et professionnels à Saint-Étienne et environs</span>
                  </li>
                </ul>
              </div>
              <div className="p-4 bg-gray-50">
                <a
                  href="#contact"
                  className="block text-center py-2 px-4 rounded font-medium transition-colors bg-white hover:bg-gray-100 text-green-600 border border-green-600"
                  aria-label="Demander un tarif de rachat de métaux à Saint-Étienne"
                >
                  Demander un tarif
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-700 italic">
            * Nos tarifs de rachat de métaux à Saint-Étienne sont mis à jour chaque semaine selon les prix du marché. Contactez votre ferrailleur épaviste pour obtenir les
            tarifs actuels et une estimation personnalisée.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Prices
